import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthSession } from './useAuthSession';

/**
 * Navigates when session state requires a different auth route.
 * @param {() => string | null} getRedirect - returns path or null to stay
 * @param {{ once?: boolean }} options - once: only redirect once per mount (guest complete login)
 */
export function useAuthRedirect(getRedirect, options = {}) {
  const navigate = useNavigate();
  const location = useLocation();
  const session = useAuthSession();
  const redirectedRef = useRef(false);
  const getRedirectRef = useRef(getRedirect);
  const { once = false } = options;

  getRedirectRef.current = getRedirect;

  useEffect(() => {
    const target = getRedirectRef.current(session);

    if (!target || target === location.pathname) {
      return;
    }

    if (once && redirectedRef.current) {
      return;
    }

    redirectedRef.current = true;
    navigate(target, { replace: true });
  }, [session, location.pathname, navigate, once]);
}
